(function ($) {
  "use strict";

  // Globo Product OptionsのUI初期化後に、送信されるvariant値をUIの先頭選択に合わせる
  var GloboVariantSync = {
    // 初期化待ち設定（Globoの描画が遅れるケースを想定）
    config: {
      firstWaitTime: 600, // 初回実行時の待機時間（ミリ秒＝初期待機＋100ms）
      waitTime: 1000, // 繰り返しリトライの場合の待機時間（ミリ秒）
      retryCount: 10,
    },

    // ログ出力（行頭にファイル名プレフィックスを付ける）
    logMsg: function (message) {
      console.log("[globoVariantSync] " + message);
    },

    // ページがロードされてから（UI初期化を待ってから）同期処理を開始
    init: function () {
      // thisをコールバック内でも使うために退避
      var self = this;
      // 初回実行時に存在確認する商品フォーム
      var $productForm;

      self.logMsg("init開始");

      $(document).ready(function () {
        self.logMsg("document.ready発火");

        // 商品詳細ページ以外ではフォームが無いので何もしない
        $productForm = $("form.shopify-product-form").first();

        if ($productForm.length === 0) {
          self.logMsg("form.shopify-product-formが見つからないため終了");
          return;
        }

        self.logMsg("form.shopify-product-formを検出。waitAndSync開始");

        setTimeout(function () {
          self.waitAndSync(self.config.retryCount);
        }, self.config.firstWaitTime);
      });
    },

    // 対象フォームが見つかるまで一定回数だけリトライする
    waitAndSync: async function (restCount) {
      // thisをsetTimeout内でも使うために退避
      var self = this;

      self.logMsg("waitAndSync実行。残りリトライ回数=" + restCount);

      if (await self.syncAllForms()) {
        self.logMsg("syncAllForms成功のため終了");
        return;
      }

      if (restCount <= 0) {
        self.logMsg("リトライ回数が0以下のため終了");
        return;
      }

      self.logMsg("対象未検出のため再試行を予約");

      await new Promise(function (resolve) {
        setTimeout(resolve, self.config.waitTime);
      });
      await self.waitAndSync(restCount - 1);
    },

    // ページ内の対象フォームを順番に同期する
    syncAllForms: async function () {
      // 各フォームの同期処理を呼ぶための参照
      var self = this;
      // 何件同期できたかを数えるカウンタ
      var syncedCount = 0;
      // .each()はasyncを待てないのでjQueryオブジェクトを配列として取得しforループで処理する
      var $forms = $(".product-detail_underdata");
      var j;

      self.logMsg("syncAllForms開始");

      for (j = 0; j < $forms.length; j += 1) {
        if (await self.syncForm($($forms[j]))) {
          syncedCount += 1;
        }
      }

      self.logMsg("syncAllForms完了。同期件数=" + syncedCount);

      return syncedCount > 0;
    },

    // 1つのフォーム内で、variant selectの先頭有効optionに対応するGloboのlabelをクリックして選択状態を揃える
    syncForm: async function ($root) {
      // thisをコールバック内でも使うために退避
      var self = this;
      // ログ用のフォームID（無ければunknown）
      var formId = "unknown";
      // カート送信用のvariant select（name="id"）
      var $variantSelect;
      // variant selectが持つoption一覧
      var $variantOptions;
      // 同期の基準とするoption（disabled無しの先頭、無ければ先頭）
      var $targetOption;
      // optionのテキスト（例："江戸間 / 1畳 / ブラウン"）
      var optionText;
      // オプションごとの選択肢
      var parts;
      // ループ用インデックス
      var i;
      // 各オプション値（トリム済み）
      var dataValue;
      // クリック対象のlabel要素
      var $label;

      formId = $root.find("form.shopify-product-form").attr("id") || "unknown";
      this.logMsg("syncForm開始。formId=" + formId);

      // 0) .single-option-selector の selected 値を削除
      // selectボックスの値は正しく更新されるが、上にかぶさっているspanが更新されない事がある。
      // このため、この処理は廃止してlabelのクリックを発火させる処理に変更。
      // $root.find(".single-option-selector option").removeAttr("selected");
      // $root.find(".single-option-selector option").prop("selected", false);

      // 1) [name=id]セレクトボックスを探す
      $variantSelect = $root.find('select[name="id"]').first();

      if ($variantSelect.length === 0) {
        this.logMsg('select[name="id"] が見つからないため終了。formId=' + formId);
        return false;
      }

      $variantOptions = $variantSelect.find("option");

      if ($variantOptions.length === 0) {
        this.logMsg('select[name="id"] のoptionが無いため終了。formId=' + formId);
        return false;
      }

      // 2) [disabled]になっていない先頭optionを探す
      $targetOption = $variantOptions
        .filter(function () {
          return !$(this).is("[disabled]");
        })
        .first();

      // 見つからなかったら先頭optionを使用
      if ($targetOption.length === 0) {
        this.logMsg("disabledでないoptionが無いため先頭optionを使用。formId=" + formId);
        $targetOption = $variantOptions.first();
      }

      optionText = $.trim($targetOption.text());
      this.logMsg("対象option text=" + optionText + ", formId=" + formId);

      // 3) optionのテキストを"/"で分割して各値を取得
      // parts = optionText.split("/"); // optionTextに「/」が含まれていた場合に問題になる
      // →後で別の方法で取得するように変更
      // →theme.liquidの「const currentProductInfo = {{ product | json }};」から取得
      // ただし、currentProductInfoがundefinedの場合は従来の処理でフォールバック
      parts = [];
      if (typeof currentProductInfo !== "undefined" && typeof currentProductInfo.variants !== "undefined") {
        for (const variant of currentProductInfo.variants) {
          const variantOptionText = variant.options.join(" / ");
          this.logMsg("選択肢クリック用パーツ生成チャレンジ: " + variantOptionText + ", formId=" + formId);
          if (optionText === variantOptionText) {
            parts = variant.options;
            this.logMsg("選択肢クリック用パーツ生成成功: " + parts.join(", ") + ", formId=" + formId);
            break;
          }
        }
      } else {
        parts = optionText.split("/"); // フォールバック/旧処理
        this.logMsg("currentProductInfoが未定義のため旧処理でpartsを生成（フォールバック）: " + parts.join(", ") + ", formId=" + formId);
      }

      // 4) まずdiv[data-value]を全てクリックして選択状態をリセット
      // .each()はasyncを待てないのでjQueryオブジェクトを配列として取得しforループで処理する
      var $resetLabels = $root.find("div[data-value] > label");
      var k;
      for (k = 0; k < $resetLabels.length; k += 1) {
        self.logMsg("labelをクリックして選択状態をリセット。data-value=" + $($resetLabels[k]).parent().attr("data-value") + ", formId=" + formId);

        // クリック時のアニメーションを長くすることでエフェクトを最小限にする
        $($resetLabels[k]).css("transition", "all 1000s");
        // 元のアニメーションは05秒なので、0.5秒後に元に戻す
        setTimeout(
          function (label) {
            $(label).css("transition", "");
          },
          500,
          $resetLabels[k],
        );

        // クリックして選択状態をリセット
        $($resetLabels[k]).trigger("click");

        // クリック間隔を少し空ける
        await new Promise(function (resolve) {
          setTimeout(resolve, 10);
        });
      }

      // partsを取得。

      // 5) 各値に対応するdiv[data-value="xxxx"]>labelを探してクリック
      for (i = 0; i < parts.length; i += 1) {
        dataValue = $.trim(parts[i]);
        $label = $root.find('div[data-value="' + dataValue + '"] > label').first();

        if ($label.length === 0) {
          this.logMsg("labelが見つからないためスキップ。data-value=" + dataValue + ", formId=" + formId);
          continue;
        }

        this.logMsg("labelをクリック。data-value=" + dataValue + ", formId=" + formId);
        await new Promise(function (resolve) {
          setTimeout(resolve, 10);
        }); // クリック間隔を少し空ける
        $label.trigger("click");
      }

      this.logMsg("syncForm完了。formId=" + formId);
      return true;
    },
  };

  GloboVariantSync.init();
})(jQuery);
